import { find } from 'lodash/fp'
import OnPremAgentClient from '~/api/OnPremAgentClient/OnPremAgentClient'
import {
  GetValidInstrumentTypesResponse,
  InstrumentType,
} from '~/api/onPremAgent/dataIngestorsAPI'
import useOnPremAgentQuery from '~/api/onPremAgent/useOnPremAgentQuery'
import Select, { SelectOption } from '~/components/Select'
import { getInstrumentImage, INSTRUMENT_DISPLAY_NAMES } from '~/utils/instrument'
import cs from './data_ingestor_instrument_select.scss'

interface DataIngestorOption {
  key: InstrumentType
  label: string
}

export default function DataIngestorInstrumentSelect({
  className,
  selectedInstrument,
  onInstrumentSelect,
}: {
  className?: string
  selectedInstrument: InstrumentType | null
  onInstrumentSelect: (instrument: InstrumentType) => void
}) {
  let { loading, data } = useOnPremAgentQuery<null, GetValidInstrumentTypesResponse>({
    backendQueryParams: {
      apiQuery: async (client: OnPremAgentClient) =>
        client.dataIngestors.getValidInstrumentTypes(),
      apiParams: null,
    },
  })

  const renderInstrument = (option: SelectOption) => (
    <div className={cs.instrumentOption}>
      <img
        className={cs.instrumentImage}
        src={getInstrumentImage({ instrumentType: option.key, instrumentName: '' })}
      />
      <span className={cs.instrumentType}>{option.label}</span>
    </div>
  )

  const menuOptions =
    data?.valid_instrument_types.map(instrumentType => ({
      key: instrumentType,
      label: INSTRUMENT_DISPLAY_NAMES[instrumentType] || instrumentType,
    })) || []

  return (
    <Select<DataIngestorOption>
      placeholder='Select instrument type'
      className={className}
      triggerClassName={cs.trigger}
      popoverClassName={cs.popover}
      items={menuOptions}
      loading={loading}
      loadingMessage='Loading'
      itemKey='key'
      itemLabelKey='label'
      activeItem={find(['key', selectedInstrument], menuOptions) || null}
      onChange={(option: DataIngestorOption) => onInstrumentSelect(option.key)}
      itemRenderer={renderInstrument}
    />
  )
}
